/**
 * Leaf constants for the SDF algorithm family.
 *
 * This module has **no imports** so it can be referenced at
 * module-evaluation time from anywhere without pulling in heavier
 * modules. `ContourTexture` re-exposes these as
 * `ContourTexture.SDF_THRESHOLD` / `ContourTexture.DEFAULT_MARGIN`, so
 * they remain the canonical public accessors and the values are always
 * identical — this file is simply the single source of truth.
 *
 * Why it exists: the Interpolation tool's image-guided path makes
 * `ContourOperations` import `IntensityRefinement`, closing the cycle
 * `ContourTexture → … → ContourOperations → IntensityRefinement → ContourTexture`.
 * `IntensityRefinement`'s module-level default option objects read the
 * iso-threshold at evaluation time; reading it from `ContourTexture`
 * during that cycle observes the class mid-initialisation (its static is
 * still `undefined`) and throws. Sourcing the constant from this
 * dependency-free leaf breaks that eval-time edge.
 */

/**
 * SDF iso-value separating inside (>=) from outside (<) the structure.
 * Stored as a `Uint8`-centred half-step so a value of 128 is just
 * inside and 127 just outside.
 */
export const SDF_ISO_THRESHOLD = 127.5;

/**
 * Default SDF falloff margin in millimetres — the distance over which
 * the signed distance is clamped and quantised into `[0, 255]`. Drives
 * the mm↔byte conversion factor (`SDF_ISO_THRESHOLD / margin`).
 */
export const SDF_DEFAULT_MARGIN_MM = 10;
